module.exports = __webpack_public_path__ + "static/media/shensu.834f678c.svg";